import { AxiosError } from 'axios';
import { HTTPClient } from './httpClient';

const ACCESS_MANAGEMENT_API_URL: string = import.meta.env
  .VITE_ACCESS_MANAGEMENT_API_URL;

const http = new HTTPClient(ACCESS_MANAGEMENT_API_URL);

/**
 * Fetches user permissions for a given canonicalId and Comet account
 * @param canonicalId - user id
 * @param xCometAccount - Comet account id
 * @returns - object containing read, create, and update permissions
 */
export async function fetchUserPermissions(
  canonicalId: string,
  xCometAccount: string,
): Promise<{ read: boolean; create: boolean; update: boolean }> {
  const FIXED_TYPE = 'comet_operations_workspace';
  const ENTITY_TYPE_ROLE_SUFFIX = 'entity_types';

  const userPermissions = {
    read: false,
    create: false,
    update: false,
  };

  const url = `/v1/accounts/principals/${canonicalId}/types/${FIXED_TYPE}/resources/${xCometAccount}/permissions`;

  try {
    const permissions: string[] = await http.get(
      url,
      undefined,
      ACCESS_MANAGEMENT_API_URL,
      {
        'x-comet-account': xCometAccount,
      },
    );
    if (permissions?.length) {
      // Filter permissions ending with the specific suffix
      const resourcePermissions = permissions.filter((perm: string) =>
        perm.endsWith(`:${ENTITY_TYPE_ROLE_SUFFIX}`),
      );

      userPermissions.read = resourcePermissions.includes(
        `read:${ENTITY_TYPE_ROLE_SUFFIX}`,
      );
      userPermissions.create = resourcePermissions.includes(
        `create:${ENTITY_TYPE_ROLE_SUFFIX}`,
      );
      userPermissions.update = resourcePermissions.includes(
        `update:${ENTITY_TYPE_ROLE_SUFFIX}`,
      );
    }
  } catch (error) {
    if (error instanceof AxiosError) {
      console.error('Error fetching user permissions:', error.message);
    } else {
      console.error('Unexpected error fetching user permissions:', error);
    }
  }

  return userPermissions;
}
